module.exports = __webpack_public_path__ + "media/flags/cr-5f3a5256.svg";